module.exports = __webpack_public_path__ + "img/gal_29.4683bc2e.png";